<template>
    <vue-tel-input :id="inputFieldId"
                   :model-value="value"
                   mode="international"
                   :disabled="data.disabled"
                   :name="name"
                   :input-options="{
                       placeholder: data.placeholder,
                       required: data.required,
                       styleClasses: (data.inputClass || '') + ' default-font-color',
                   }"
                   @on-input="input"/>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import {InputMixin} from './mixin/InputMixin.js';

export default {
    emits: ['input'],
    name: "TelInput",
    mixins: [InputMixin],
    components: {VueTelInput},
    methods: {
        input(value) {
            this.$emit("input", value);
        }
    }
}
</script>
